import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import { SalesSettings } from '../interfaces/sales/salesSettings.interface';

export const SalesSettingsService = {
  getByInstitution: async (institutionId: string): Promise<SalesSettings> =>
    (await axios.get(ENDPOINTS.SALES_SETTINGS.BY_INSTITUTION(institutionId))).data,
  upsert: async (dto: SalesSettings): Promise<SalesSettings> =>
    (await axios.put(ENDPOINTS.SALES_SETTINGS.UPSERT, dto)).data,
};
